// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import {
  Profil,
  Settings,
} from './';

import { by } from '../../common/routerAccess';

export default {
  path: 'user',
  name: 'User',
  access: by.only.USER,
  childRoutes: [
    { path: 'profil', name: 'Profil', component: Profil},
    { path: 'settings', name: 'Settings', component: Settings }
  ],
};



// WEBPACK FOOTER //
// ./src/features/user/route.js